import { MS_PER_DAY } from '../../utils/timeUnits'

const GPS9_EPOCH_MS = Date.UTC(2000, 0, 1)

export const gps9TimeMs = (days: number, msOfDay: number): number =>
  GPS9_EPOCH_MS + days * MS_PER_DAY + msOfDay
